import React, { lazy } from 'react';
import { motion } from 'framer-motion';
export function PainSection() {
  return <section className="bg-[#FFF5F0] px-4 py-14 sm:px-6 lg:px-8 lg:py-20" data-id="element-154">
      <div className="mx-auto max-w-3xl" data-id="element-155">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} data-id="element-156">
          <h2 className="mb-8 font-serif text-4xl font-bold text-[#2D2D2D] sm:text-5xl" data-id="element-157">
            Let me describe your last 3 months.
          </h2>

          <div className="space-y-6 font-sans text-xl leading-loose text-[#2D2D2D]/90" data-id="element-158">
            <p data-id="element-159">
              You wake up before your alarm — because the alarm is a baby, and
              babies don't snooze. You feed, soothe, burp, change, settle,
              repeat. Somewhere between all of that, you try to eat something.
              Maybe you drink cold coffee. Maybe you don't eat at all.
            </p>
            <p data-id="element-160">
              By afternoon, the exhaustion has a weight to it. Not just
              physical. Existential.
            </p>
            <p data-id="element-161">
              You scroll past a fitness influencer talking about "postpartum
              body goals" and something inside you — something you can't name —
              flinches.
            </p>

            <div className="my-6 space-y-4 pl-8" data-id="element-162">
              <p className="font-serif text-2xl italic text-[#D4603A]" data-id="element-163">
                Not because you're lazy.
              </p>
              <p className="font-serif text-2xl italic text-[#D4603A]" data-id="element-164">
                Not because you don't care.
              </p>
            </div>

            <p data-id="element-165">
              But because somewhere along the way, you stopped being a person
              with goals and became a person whose entire existence is organized
              around someone else's needs.
            </p>

            <motion.div initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} className="my-8 border-l-4 border-[#81B29A] py-4 pl-8 bg-white/50 rounded-r-lg" data-id="element-166">
              <p className="font-serif text-2xl font-bold leading-relaxed text-[#2D2D2D]" data-id="element-167">
                And here's the part nobody talks about:
                <br data-id="element-168" />
                You love your baby completely and you're also grieving yourself.
                Both things are true at the same time.
              </p>
            </motion.div>

            <p data-id="element-169">
              The old jeans sit at the back of the closet. Not because you've
              given up. Because pulling them out feels like touching a bruise.
            </p>
            <p data-id="element-170">
              You've tried things. You ate less. You pushed through a workout at
              6 AM on four hours of sleep. You followed the plan for eleven days
              before the exhaustion and hunger and guilt became louder than the
              motivation.
            </p>
            <p data-id="element-171">
              And then the cruelest voice of all showed up — the one that said:
            </p>

            <div className="my-8 text-center" data-id="element-172">
              <p className="font-serif text-3xl font-bold italic text-[#2D2D2D]" data-id="element-173">
                "Maybe you just don't have what it takes anymore."
              </p>
            </div>

            <p className="font-bold text-[#D4603A]" data-id="element-174">
              You don't need to hear that voice again. Because it was never
              telling you the truth.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}